/* eslint-disable complexity, sonarjs/cognitive-complexity, react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { PAYMENT } from '../../../config/text/text';
import BraintreeService from '../../../helpers/braintreeService';
import { showApplePay, showGooglePay } from '../../../helpers/payment';
import Spinner from '../../_generic/spinner/Spinner';
import Tile from '../../_generic/tile/Tile';
import TileBody from '../../_generic/tile/TileBody';
import AppleExpresssCheckout from '../../appleExpresssCheckout';
import GooglePayExpressCheckout from '../../googleExpressCheckout';
import PaymentMessage from './PaymentMessage';

const customError = (errors) => {
  console.error(errors);
};

const PaymentExpressPostCheckout = ({
  deviceFingerprintId,
  failedExpressBuy = false,
  finalOrderAmount,
  orderCompleteHandler,
  orderFailedHandler,
  isAuthenticated,
  orderSummary,
  paymentInstruments,
  selectedAddons,
  secondCheckout,
}) => {
  const [isCardCheckDone, setIsCardCheckDone] = useState(false);

  const handleOrderComplete = async (order) => {
    if (order) {
      orderCompleteHandler(true);
    }
  };

  const afterError = () => {
    orderFailedHandler(true);
  };

  const providerError = (error) => {
    // setErrorObject(error);
    console.log('error', error);
  };

  useEffect(() => {
    BraintreeService.totalAmountToPay = finalOrderAmount;
  }, [finalOrderAmount]);

  useEffect(() => {
    BraintreeService.addons = selectedAddons;
    BraintreeService.isPostCheckout = true;
    BraintreeService.productOrderId = orderSummary.productOrderId;
    BraintreeService.dealVoucherProductId = orderSummary.dealVoucherProductId;
    if (secondCheckout) {
      BraintreeService.sendEmail = false;
    } else {
      BraintreeService.sendEmail = true;
    }
  }, [selectedAddons, orderSummary]);

  useEffect(() => {
    BraintreeService.deviceFingerprintId = deviceFingerprintId;
  }, [deviceFingerprintId]);

  useEffect(() => {
    setTimeout(() => {
      if (!isCardCheckDone) {
        setIsCardCheckDone(true);
      }
    }, 2_500);
  }, []);

  return (
    <>
      {!isCardCheckDone && <Spinner hasMsg={false} />}
      {failedExpressBuy && <PaymentMessage />}
      <Tile extraClasses="payment" title={PAYMENT}>
        <TileBody nobackground>
          {showGooglePay({
            finalOrderAmount,
            isAuthenticated,
            paymentInstruments,
          }) && (
            <GooglePayExpressCheckout
              afterError={afterError}
              basketProducts={[]}
              customError={customError}
              finalOrderAmount={finalOrderAmount}
              isAuthenticated={isAuthenticated}
              isPostCheckout
              orderComplete={handleOrderComplete}
              orderSummary={orderSummary}
              totalQuantity={1}
            />
          )}
          {showApplePay({
            finalOrderAmount,
            isAuthenticated,
            paymentInstruments,
          }) && (
            <AppleExpresssCheckout
              basketProducts={[]}
              finalOrderAmount={finalOrderAmount}
              isPostCheckout
              orderComplete={handleOrderComplete}
              orderSummary={orderSummary}
              providerError={providerError}
              totalQuantity={1}
            />
          )}
        </TileBody>
      </Tile>
    </>
  );
};

PaymentExpressPostCheckout.propTypes = {
  deviceFingerprintId: PropTypes.string,
  failedExpressBuy: PropTypes.bool,
  finalOrderAmount: PropTypes.number,
  isAuthCheckFinished: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
  orderCompleteHandler: PropTypes.func,
  orderFailedHandler: PropTypes.func,
  orderSummary: PropTypes.object.isRequired,
  paymentInstruments: PropTypes.any,
  secondCheckout: PropTypes.bool,
  selectedAddons: PropTypes.array,
};

export default PaymentExpressPostCheckout;
